import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class HREmployeeActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Employee/EmployeeBrowser")
	}

	render() {
		return (
			<Activity 
				name="HREmployee"
				RenderedComponent={this.RenderedComponent}
				context="HREmployee"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(HREmployeeActivity)
